<template lang="html">
  <router-view></router-view>
</template>

<script>
import { inject } from '@vercel/analytics';

export default {
  mounted() {
    if (process.env.VUE_APP_COOKIE_ENV === 'production') {
      inject();
    }
  }
}
</script>
